<template>
  <div v-if="lang === 'java' || lang === 'kotlin'">
    <Heading tag="h2">{{ $t('examples.run.runYourCode') }}</Heading>
    <i18n-t keypath="examples.run.updateGradleFile" tag="p" scope="global">
      <template #application>
        <code>application</code>
      </template>
      <template #gradleFile>
        <code>build.gradle</code>
      </template>
    </i18n-t>
    <code-snippet
      lang="groovy"
      :code="`apply plugin: 'application'\nmainClassName = project.hasProperty('main') ? project.getProperty('main') : ''`"
    />
    <i18n-t keypath="examples.run.runGradleCommand" tag="p" scope="global">
      <template #gradle>
        <code>gradle</code>
      </template>
      <template #package>
        <code>{{ javaPackageName }}</code>
      </template>
      <template #class>
        <code>{{ javaClassName }}</code>
      </template>
    </i18n-t>
    <TermynalSnippet>
      <span data-ty="input">gradle run -Pmain={{ javaPackageName }}.{{ javaClassName }}</span>
    </TermynalSnippet>
  </div>
  <div v-else-if="shouldRenderRunCommand">
    <Heading tag="h2">{{ $t('examples.run.runYourCode') }}</Heading>
    <p>{{ $t('examples.run.saveThisFileToYourMachineAndRunIt') }}</p>
    <TermynalSnippet>
      <span data-ty="input">{{ command }}</span>
    </TermynalSnippet>
  </div>
  <div v-else />
</template>

<script lang="ts" setup>
import { computed } from 'vue';
import { CodeSnippet } from '@/components/markdown/widgets';
import TermynalSnippet from '@/components/markdown/widgets/TermynalSnippet.vue';
import Heading from '@/components/example/components/Heading.vue';

const props = defineProps({
  lang: { type: String, required: true },
  fileName: { type: String, required: true },
  command: { type: String },
  javaPackageName: { type: String },
});

const javaClassName = computed(() => props.fileName.replace(/\.(java|kt)$/, ''));

const shouldRenderRunCommand = computed(() =>
  ['curl', 'go', 'javascript', 'php', 'python', 'ruby', 'swift'].includes(props.lang)
);
</script>
